import React from 'react';
import StonesStore from "./../../stores/stonesStore";

export default () => {
  const f = StonesStore.fabricator();
  if (!f.ReviewMessage) {
    return null;
  }

  return (
    <div className="disclaimer-message-panel">
      <div className="disclaimer-alert-icon"/>
      <div className="disclaimer-red-lable"/>
      <div className="disclaimer-text">{f.ReviewMessage}</div>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/projectSummary/disclaimer.js